import {Navigate, Outlet, useLocation} from 'react-router-dom'
import {Center, Spinner} from '@chakra-ui/react'
import {useAppSelector} from '../hooks/store.ts'
import {isBarberLoggedIn} from '../slices/authSlice.ts'
import {useGetCurrentUserQuery} from '../services/userService.ts'
import {hasAdminRole} from '../types'

// Gates /admin/* — requires a logged-in barber whose roles include
// ROLE_ADMIN or ROLE_SUPER_ADMIN. Mirrors the BE guard
// (#[IsGranted(Barber::ROLE_ADMIN)]) so non-admin barbers can't even reach
// the form.
export function AdminOutlet() {
    const location = useLocation()
    const isLogged = useAppSelector(isBarberLoggedIn)
    const {data: user, isLoading} = useGetCurrentUserQuery(undefined, {skip: !isLogged})

    if (!isLogged) {
        return <Navigate to="/login" state={{from: location}} replace/>
    }
    if (isLoading) {
        return (
            <Center h="60vh">
                <Spinner size="xl" color="blue.500" borderWidth="4px"/>
            </Center>
        )
    }
    if (!hasAdminRole(user?.roles)) {
        return <Navigate to="/dashboard" replace/>
    }
    return <Outlet/>
}
